<template>
  <div class="sign">
    <div class="header bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div class="left acea-row row-between-wrapper">
          <div class="pictrue"><img :src="userInfo.avatar" /></div>
          <div class="text">
            <div class="line1">{{ userInfo.nickname }}</div>
            <div class="integral acea-row">
              <span>橙币: {{ userInfo.integral || 0 }}</span>
            </div>
          </div>
        </div>
        <router-link
          :to="'/user/sign_record'"
          class="right acea-row row-middle"
        >
          <div class="iconfont icon-caidan"></div>
          <div>明细</div>
        </router-link>
      </div>
    </div>
    <div class="wrapper" v-if="userInfo">
      <div class="list acea-row row-between-wrapper">
        <div class="hello">
          <CalendarSignIn
            ref="calendarSignIn"
            :signNum="userInfo.signNum"
            :isDaySign="userInfo.isDaySign"
            :config="signSystemList"
            :rewardType="rewardType"
          ></CalendarSignIn>
        </div>
      </div>
      <!--加在 but 上 on 为已签到-->
      <div
        class="but bg-color-red"
        :class="userInfo.isDaySign ? 'on' : ''"
        @click="goSign"
      >
        {{ userInfo.isDaySign ? "已签到" : "立即签到" }}
      </div>
      <div class="lock"></div>
    </div>
    <div class="wrapper wrapper2">
      <div class="tip">已累计签到</div>
      <div class="list2 acea-row row-center row-bottom">
        <div class="item" v-for="(item, index) in signCount" :key="index">
          {{ item || 0 }}
        </div>
        <div class="data">天</div>
      </div>

      <div class="list3">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item, index) in signList.slice(0, 3)"
          :key="index"
        >
          <div>
            <div class="name line1">{{ item.title }}</div>
            <div class="data">{{ item.addTime }}</div>
          </div>
          <div class="num font-color-red">+{{ item.number }}</div>
        </div>
        <router-link
          :to="'/user/sign_record'"
          class="Loads acea-row row-center-wrapper"
          v-if="signList.length > 0"
        >
          点击加载更多
          <div class="iconfont icon-xiangyou acea-row row-center-wrapper"></div>
        </router-link>
      </div>
    </div>
    <div
      class="signTip acea-row row-center-wrapper"
      :class="active === true ? 'on' : ''"
    >
      <div class="signTipLight loadingpic"></div>
      <div class="signTipCon">
        <div class="state">签到成功</div>
        <div class="integral">获得{{ integral }}橙币</div>
        <div class="signTipBnt" @click="close">好的</div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="active === false"></div>
  </div>
</template>
<style scoped>
.Loads .iconfont {
  font-size: 0.25rem;
  margin: 0.02rem 0 0 0.1rem;
}
</style>
<script>
import {
  postSignUser,
  getSignConfig,
  postSignIntegral,
  getSignList
} from "@api/user";
import { add } from "@utils/bc";
import { formate } from "@utils/index";
import CalendarSignIn from "@components/CalendarSignIn";

export default {
  name: "Sign2",
  components: {
    CalendarSignIn
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      integral: 0,
      signCount: [],
      signList: [],
      active: false,
      day: "",
      signSystemList: [],
      rewardType: "continuous"
    };
  },
  mounted: function() {
    this.signUser();
  },
  methods: {
    // js给数字补0；num：需要补0的数字，length：长度（补到多少位）；
    PrefixInteger: function(num, length) {
      return (Array(length).join("0") + num).slice(-length).split("");
    },
    // 获取用户信息
    signUser: function() {
      let that = this;
      postSignUser({ sign: 1 }).then(res => {
        that.userInfo = res.data;
        res.data.integral = parseInt(res.data.integral);
        var sumSginDay = res.data.sumSignDay;
        that.signCount = that.PrefixInteger(sumSginDay, 4);
        this.signConfig();
      });
    },
    // 签到配置
    signConfig: function() {
      let that = this;
      getSignConfig().then(res => {
        that.signSystemList = res.data.list;
        that.rewardType = res.data.rewardType;
        this.getSignList();
      });
    },
    //  用户签到
    goSign: function() {
      let that = this,
        sumSginDay = that.userInfo.sumSignDay;
      if (that.userInfo.isDaySign)
        return that.$dialog.toast({ mes: "您今日已签到!" });
      postSignIntegral()
        .then(res => {
          that.active = true;
          that.integral = res.data.integral;
          that.signCount = that.PrefixInteger(sumSginDay + 1, 4);
          that.userInfo.isDaySign = true;
          that.userInfo.integral = add(
            that.userInfo.integral,
            res.data.integral
          );
          that.userInfo.signNum = add(that.userInfo.signNum, 1);
          that.getSignList();
        })
        .catch(err => {
          that.$dialog.toast({ mes: err.msg });
        });
    },
    //  获取签到列表;
    getSignList: function() {
      let that = this;
      getSignList().then(res => {
        that.signList = res.data;
        this.$nextTick(() => {
          this.$refs.calendarSignIn.createData(res.data);
        });
      });
    },
    close: function() {
      this.active = false;
    }
  }
};
</script>
